(function () {
  var mapEl = document.querySelector('[data-olfa-vibe-map]');
  if (!mapEl) return;

  var raw;
  try { raw = JSON.parse(mapEl.textContent); } catch (e) { return; }

  var norm = function (s) {
    return String(s)
      .replace(/[\u2018\u2019\u02BC\u0060\u00B4]/g, "'")
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  };

  var map = {};
  Object.keys(raw).forEach(function (k) { map[norm(k)] = raw[k]; });

  var update = function (option) {
    if (!option || option.querySelector('.od-current')) return;

    var label = option.querySelector('.ProductForm__Label');
    var checked = option.querySelector('.SizeSwatch__Radio:checked, .ColorSwatch__Radio:checked');
    if (!label || !checked) return;

    var text = map[norm(checked.value)];
    var span = label.querySelector('.ofn-current');

    if (!text) { if (span) span.remove(); return; }

    if (!span) {
      span = document.createElement('span');
      span.className = 'ofn-current';
      label.appendChild(span);
    }
    if (span.textContent !== text) span.textContent = text;
  };

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.classList) return;
    if (!t.classList.contains('SizeSwatch__Radio') && !t.classList.contains('ColorSwatch__Radio')) return;
    update(t.closest('.ProductForm__Option'));
  });
})();